<template>
  <!--
    BillCellElementLite: счета (Category Bills, DisplayType 18).
    Сам Bill это объект, его рисует общий компонент bill-row, зарегистрированный
    глобально. Здесь только обёртка-ряд.
  -->
  <div class="qtl-bill">
    <bill-row v-for="(rec, i) in bills" :key="i" :el="rec" />
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { TableDataCellDisplayType } from "@/models/etc/types";
import type { CellDataBill, TableDataCell } from "@/models/interfaces/entity-settings/querytable/querytable";

const props = defineProps<{ element: TableDataCell }>();

// Наружу отдаём объекты Bill, форматирует их bill-row. Для не-Bill ничего не рисуем.
const bills = computed(() => {
  if (props.element.DisplayType === TableDataCellDisplayType.Bill) {
    return (props.element.Data as CellDataBill[]).map((d) => d.Bill);
  }
  return [];
});
</script>

<style lang="scss" scoped>
.qtl-bill {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  max-width: 100%;
  font-size: 13px;
}
</style>
